import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';
import { aladb } from 'db'
import { Chart } from 'react-google-charts';

import './CardPhoneTabletUsage.css'

export default () => {
	const sqlDataPhone = aladb.db.exec(`SELECT COUNT(*) AS cnt FROM Log WHERE phone IS NOT NULL`);
	const sqlDataTablet = aladb.db.exec(`SELECT COUNT(*) AS cnt FROM Log WHERE tablet IS NOT NULL`);

	const data = [
		['Empty', 'Smartphone', 'Tablet'],
		['', sqlDataPhone[0].cnt, sqlDataTablet[0].cnt]
	];

	const options = {
		pieHole: 0.4,
		legend: {
			position: 'top',
			textStyle: {fontSize: 20}
		},
		bar: { groupWidth: '75%' },
		isStacked: "percent",
		chartArea: {
			top: 40,
			bottom: 80,
			left: 30,     // set this eventually, to adjust the left margin
			right: 30,
		},
		fontSize: 16,
	};

	return (
		<Card>
			<CardTitle title="Smartphone vs. Tablet Einsatz"/>
			<CardText>
				<Chart
					chartType="BarChart"
					data={data}
					options={options}
					graph_id="chart-phone-tablet-usage"
				/>
			</CardText>
		</Card>
	);
};


// WEBPACK FOOTER //
// ./src/components/summary/cards/CardPhoneTabletUsage.jsx